import { getUrlParams } from './utils';

const COMMON_PARAM_KEY = 'point_common_param';

// 初始化公共参数到缓存
export const initCommonParamStorage = () => {
  const params = {
    packageName: getUrlParams('packageName') || '',
    devicePlate: getUrlParams('devicePlate') || '',
    cid: getUrlParams('cid') || '',
    scid: getUrlParams('scid') || '',
    loginAccount: '',
    uid: '',
    roleId: '',
    roleName: '',
    serverId: ''
  };
  updateCommonParamsInfo(params);
};

export const updateCommonParamsInfo = params => {
  if (!params) {
    return;
  }
  let info = getCommonParamsInfo();
  if (!info) {
    setCommonParamsInfo(params);
    return;
  }
  setCommonParamsInfo(Object.assign({}, info, params));
};

export const getCommonParamsInfo = () => {
  let info = '';
  try {
    info = JSON.parse(sessionStorage.getItem(COMMON_PARAM_KEY));
  } catch (e) {
    console.log(e);
  }
  return info;
};

const setCommonParamsInfo = params => {
  if (!params) {
    return;
  }
  try {
    sessionStorage.setItem(COMMON_PARAM_KEY, JSON.stringify(params));
  } catch (e) {
    console.log(e);
  }
};
